import dayjs from 'dayjs'
import { useCallback } from 'react'

import useGetCompanyQuota from './api/useGetCompanyQuota'
import useUser from './useUser'

const useCompanyBenefits = () => {
  const { company, companyId } = useUser()

  const benefitIsValid = dayjs(company?.CompanyEmployee?.validUntil).isAfter(dayjs())
  const { data: quotas, refetchQuota, isLoading } = useGetCompanyQuota(companyId)
  const metaWorkplaceMemberId = company?.CompanyEmployee?.metaWorkplaceMemberId
  const employeeCodeId = company?.CompanyEmployee?.companyEmployeeCodeId
  const activationLinkId = company?.CompanyEmployee?.activationLinkId
  const blinkClientId = company?.CompanyEmployee?.blinkClientId

  const shouldHidePriceForService = useCallback(
    (serviceId?: number) => {
      if (!serviceId) return false
      return quotas?.some((quota) => quota.services.includes(serviceId) && Boolean(quota.hidePrice))
    },
    [quotas],
  )

  return {
    hasBenefitProgram: Boolean(company),
    shouldHidePriceForService,
    benefitIsValid,
    quotas,
    refetchQuota,
    isLoading,
    company,
    metaWorkplaceMemberId,
    employeeCodeId,
    activationLinkId,
    blinkClientId,
  }
}

export default useCompanyBenefits
